export default "__VITE_ASSET__C71O5VHh__"